import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./AuthSlice";
import AdminSlice from "./AdminSlice";
import ProductSlice from "./ProductSlice";
import DriversSlice from "./DriversSlice";
import RestaurantsSlice from "./RestaurantsSlice";
import HomeSlice from "./HomeSlice";
import ConrtactSlice from "./ConrtactSlice";
import DiscountSlice from "./DiscountSlice";
import StstisticsSlice from "./StstisticsSlice";
import CartSlice from "./CartSlice";

export default configureStore({
  reducer: {
    AuthSlice,
    AdminSlice,
    ProductSlice,
    DriversSlice,
    RestaurantsSlice,
    HomeSlice,
    ConrtactSlice,
    DiscountSlice,
    StstisticsSlice,
    CartSlice,
  },
});
